import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable, throwError as observableThrowError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

import { ConfigurationService } from '../core/configuration.service';
import { AnyAaaaRecord } from 'dns';

@Injectable()
export class ChequebookService {
    private baseApiUrl: string;

    constructor(configurationService: ConfigurationService, private httpClient: HttpClient) {
        this.baseApiUrl = configurationService.BaseApiUrl;
    }

    getFiltered(filter: string, pageIndex: number, pageSize: number,
        sortColumn: string, sortAscending: boolean, isMaintenance: boolean = false): Observable<any> {

        const params = {
            filter, pageIndex, pageSize, sortColumn, sortAscending, isMaintenance
        };

        return this.httpClient.post(this.baseApiUrl + 'chequebook/filter', params).pipe(
            map((res: any) => res),
            catchError((err: any) => observableThrowError(err.message || 'Server error')));
    }

    getAll(forMaintenance: boolean = false): Observable<any> {
        return this.httpClient.get(this.baseApiUrl + `chequebook?isMaintenance=${forMaintenance}`).pipe(
            map((res: any) => res),
            catchError((err: any) => observableThrowError(err.message || 'Server error')));
    }


    computeInstallmentAndFees(computeData: any): Observable<any> {
      return this.httpClient.post(this.baseApiUrl + `chequebook/compute`, computeData).pipe(
        map((res: Response) => res),
        catchError((err: any) => observableThrowError(err.message || 'Server error')));
    }


    getById(id: number, forMaintenance: boolean = false): Observable<any> {
        return this.httpClient.get(this.baseApiUrl + `chequebook/${id}?isMaintenance=${forMaintenance}`).pipe(
            map((res: Response) => this.addChequebookDisplayData(res)),
            catchError((err: any) => observableThrowError(err.message || 'Server error')));
    }

    create(chequebook: any): Observable<any> {
        return this.httpClient.post(this.baseApiUrl + `chequebook`, chequebook).pipe(
            map((res: Response) => res),
            catchError((err: any) => observableThrowError(err.message || 'Server error')));
    }

    update(chequebook: any): Observable<any> {
        return this.httpClient.put(this.baseApiUrl + `chequebook`, chequebook).pipe(
            map((res: Response) => res),
            catchError((err: any) => observableThrowError(err.message || 'Server error')));
    }

    authorise(id: number): Observable<any> {
        return this.httpClient.post(this.baseApiUrl + `chequebook/authorise`, id).pipe(
            map((res: Response) => res),
            catchError((err: any) => observableThrowError(err.message || 'Server error')));
    }

    delete(id: number): Observable<any> {
        return this.httpClient.delete(this.baseApiUrl + `chequebook/${id}`).pipe(
            map((res: Response) => res),
            catchError((err: any) => observableThrowError(err.message || 'Server error')));
    }

    addChequebookDisplayData(chequebook: any): any {
        chequebook.displayData = `${chequebook.name} - ${chequebook.code}`;
        return chequebook;
    }

    validateChequeNo(accountno: any, chequeno: any): Observable<any> {
        return this.httpClient.get(this.baseApiUrl + `chequebook/validatechequeno/${accountno}?chequeno=${chequeno}`).pipe(
            map((res: Response) => this.addChequebookDisplayData(res)),
            catchError((err: any) => observableThrowError(err.message || 'Server error')));
    }

    getUpdateAccount(accountno: AnyAaaaRecord): Observable<any> {
        return this.httpClient.get(this.baseApiUrl + `chequebook/getIssuedCount/${accountno}`).pipe(
            map((res: Response) => this.addChequebookDisplayData(res)),
            catchError((err: any) => observableThrowError(err.message || 'Server error')));
    }

    getByAccount(accountno: any): Observable<any> {
        return this.httpClient.get(this.baseApiUrl + `chequebook/accountno/${accountno}`).pipe(
            map((res: Response) => this.addChequebookDisplayData(res)),
            catchError((err: any) => observableThrowError(err.message || 'Server error')));
    }
}
